export const GLOBAL_STATE = 'Semester'

export const SEMESTER = 'semester'
export const SEMESTER_LIST = 'semesterList'
export const SEMESTER_ALL = 'semesterAll'
